import {Component, input, computed, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-card-error",
    imports: [],
    templateUrl: "./card-error.component.html",
    styleUrl: "./card-error.component.scss",
})
export class CardErrorComponent {
    readonly $squareFormat = input(false, {alias: "squareFormat"})
    readonly $error = input<Error>(new Error("Not accessible"), {alias: "error"})

    readonly $message = computed(() => this.$error().message)
}
